import { Expose, Transform } from 'class-transformer';
import { IsBoolean, IsObject, IsOptional, IsString } from 'class-validator';
import { UnitType } from '.';
import CreatedInfo, { Created } from './created-info';
import UpdatedInfo, { Updated } from './updated-info';

export class Unit implements Created, Updated {
  @IsString()
  readonly id: string;

  @IsString()
  readonly label: string;

  @IsString()
  readonly number: string;

  @IsString()
  @IsOptional()
  readonly size?: string;

  @Expose({ name: 'section_id' })
  @IsOptional()
  readonly sectionId?: string;

  @Transform(({ value }: { value: string }) => {
    if (value === 'appartement') {
      return UnitType.Apartment;
    }

    return value;
  })
  @IsOptional()
  readonly type?: UnitType;

  @IsBoolean()
  @Transform(({ value }: { value?: boolean }) => value ?? false)
  readonly disabled: boolean;

  @IsOptional()
  @IsObject()
  readonly created?: CreatedInfo;

  @IsOptional()
  @IsObject()
  readonly updated?: UpdatedInfo;

  constructor(init?: Unit) {
    this.id = init?.id!;
    this.label = init?.label!;
    this.number = init?.number!;
    this.size = init?.size;
    this.sectionId = init?.sectionId;
    this.disabled = init?.disabled!;
    this.type = init?.type;

    this.created = init?.created ? new CreatedInfo(init?.created!) : undefined;
    this.updated = init?.updated ? new UpdatedInfo(init?.updated!) : undefined;
  }
}

export default Unit;
